export default "__VITE_ASSET__POThtcX2__"